import React, {useState, useRef, useEffect} from "react";
// import PropTypes from "prop-types";
import {Calendar} from "react-multi-date-picker";
import {months, weekDays} from "../../data/calendar";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import Button from "../Button/Button";

//todo redundant with FilterDropdown and FilterCalendar
const FilterCalendar = ({label, isLoading, dates, setDates, handleCalendarChange}) => {
  const [open, setOpen] = useState(false);
  const dropRef = useRef(null);
  const [nCalendars, setNCalendars] = useState(2)
  const [isMobile, setIsMobile] = useState(false)
  const {width} = useWindowDimensions();

  useEffect(() => {
    if (width > 1000 && nCalendars !== 2) {
      setNCalendars(2)
    } else if (width <= 1000 && nCalendars !== 1) {
      setNCalendars(1)
    }
    if (width < 768 && !isMobile) {
      setIsMobile(true)
    } else if (width >= 768 && isMobile) {
      setIsMobile(false)
    }
  }, [width])

  useEffect(() => {
    function onDocClick(e) {
      if (dropRef.current && !dropRef.current.contains(e.target)) setOpen(false);
    }

    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  const handleSetCalendarPeriod = ({days = 0, months = 0, years = 0}) => {
    const today = new Date()
    const end = new Date(today)
    if (days) end.setDate(today.getDate() + days)
    if (months) end.setMonth(today.getMonth() + months)
    if (years) end.setFullYear(today.getFullYear() + years)

    setOpen(false)

    const newDates = [today, end]
    setDates(newDates)
    handleCalendarChange(newDates)
  }

  const handleSetCalendarWeek = () => handleSetCalendarPeriod({days: 7})
  const handleSetCalendarMonth = () => handleSetCalendarPeriod({months: 1})
  const handleSetCalendarYear = () => handleSetCalendarPeriod({years: 1})
  const handleSetCalendarPrevMonth = () => handleSetCalendarPeriod({months: -1})

  const toJSDate = (d) => {
    if (!d) return null
    return typeof d.toDate === "function" ? d.toDate() : d
  }

  const isPeriodSelected = ({days = 0, months = 0, years = 0}) => {
    if (!dates?.[0] || !dates?.[1]) return false

    const today = new Date()
    const end = new Date(today)
    if (days) end.setDate(today.getDate() + days)
    if (months) end.setMonth(today.getMonth() + months)
    if (years) end.setFullYear(today.getFullYear() + years)

    const startDate = toJSDate(dates[0])
    const endDate = toJSDate(dates[1])

    return startDate.toDateString() === today.toDateString() &&
      endDate.toDateString() === end.toDateString()
  }

  const isWeekSelected = () => isPeriodSelected({days: 7})
  const isMonthSelected = () => isPeriodSelected({months: 1})
  const isYearSelected = () => isPeriodSelected({years: 1})
  const isPrevMonthSelected = () => isPeriodSelected({months: -1})

  const getDynamicLabel = () => {
    if (isWeekSelected()) return "komende week"
    if (isMonthSelected()) return "komende maand"
    if (isYearSelected()) return "komend jaar"
    if (isPrevMonthSelected()) return "vorige maand"

    if (!dates?.[0] || !dates?.[1]) return label

    const start = toJSDate(dates[0])
    const end = toJSDate(dates[1])
    const options = { day: "2-digit", month: "2-digit" }
    return `${start.toLocaleDateString("nl-NL", options)} – ${end.toLocaleDateString("nl-NL", options)}`
  }

  return (
    <div className="component-filter-calendar">
      <div className="filter-dropdown" ref={dropRef}>
        <button
          type="button"
          className="filter-dropdown__trigger"
          onClick={() => setOpen(v => !v)}
        >
          {getDynamicLabel()} <span className="arrow">{open ? "▲" : "▼"}</span>
        </button>

        {open && (
          <div className="filter-dropdown__menu">

            <div className="row buttons">
              <Button
                label="komende week"
                size="xs"
                color={isWeekSelected() ? "grey" : "grey-ghost"}
                onClick={() => handleSetCalendarWeek()}
              />
              <Button
                label="komende maand"
                size="xs"
                color={isMonthSelected() ? "grey" : "grey-ghost"}
                onClick={() => handleSetCalendarMonth()}

              />
              <Button
                label="komend jaar"
                size="xs"
                color={isYearSelected() ? "grey" : "grey-ghost"}
                onClick={() => handleSetCalendarYear()}
              />
              <Button
                label="vorige maand"
                size="xs"
                color={isPrevMonthSelected() ? "grey" : "grey-ghost"}
                onClick={() => handleSetCalendarPrevMonth()}
              />
            </div>

            <Calendar
              range
              disabled={isLoading}
              value={dates}
              weekStartDayIndex={1}
              shadow={false}
              weekDays={weekDays}
              months={months}
              numberOfMonths={nCalendars}
              onChange={handleCalendarChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};

// FilterCalendar.propTypes = {
//   filters: PropTypes.arrayOf(
//     PropTypes.shape({
//       key: PropTypes.string.isRequired,
//       label: PropTypes.string.isRequired,
//       type: PropTypes.string,
//       enabled: PropTypes.bool,
//     })
//   ).isRequired,
//   handleFilterSwitch: PropTypes.func.isRequired,
// };

export default FilterCalendar;
